import React, { useEffect, useState } from "react";
import { MainContainer, Section } from "./styles";
import Typography from "../../../../components/Typography";
import SectionItem from "../../../../components/SectionItem";
import { Divider } from "antd";
import { briefingService } from "../../../../services/modules/briefing";
import useEnterprise from "../../hooks/useEnterprise";
import { Briefing as BriefingType } from "./types";
import WaitingMessage from "../../../../components/WaitingMessage";
import { SkeletonLoading } from "../skeleton";
import useAuth from "../../../../hooks/useAuth";

const Briefing: React.FC = (): JSX.Element => {
  const { authState } = useAuth();
  const { enterpriseState } = useEnterprise();

  const [briefingData, setBriefingData] = useState<BriefingType>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchBriefing = (id: string) => {
    authState.accountData &&
      briefingService
        .getBriefing(id)
        .then((response) => setBriefingData(response))
        .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (enterpriseState.selectedEnterprise)
      fetchBriefing(enterpriseState.selectedEnterprise);
  }, [enterpriseState.selectedEnterprise]);

  return (
    <Section>
      {isLoading ? (
        <SkeletonLoading />
      ) : (
        <>
          {briefingData ? (
            <MainContainer>
              <Typography
                text={enterpriseState.enterpriseData?.company_name}
                size="extraHuge"
                color="Black500"
                weight={700}
              />
              <SectionItem
                icon={"🏢"}
                title={"Site da Empresa"}
                description={enterpriseState.enterpriseData?.website || ""}
              />
              <Divider />
              <SectionItem
                icon={"🌎"}
                title={"LOCALIZAÇÃO"}
                description={"Informações sobre localização da empresa."}
                isTitle
              />
              <SectionItem
                icon={"🏙️"}
                title={"Cidade"}
                description={briefingData.address.city}
              />
              <SectionItem
                icon={"🗺️"}
                title={"Estado"}
                description={briefingData.address.state}
              />
              <SectionItem
                icon={"📍"}
                title={"País"}
                description={briefingData.address.country}
              />
              <Divider />
              <SectionItem
                icon={"👥"}
                title={"ESTRUTURA E FUNCIONAMENTO"}
                description={
                  "Detalhes sobre a estrutura da empresa, incluindo número de funcionários, modelo de receita e tamanho da operação. Essas variáveis ajudam a entender o porte e a forma de monetização da empresa."
                }
                isTitle
              />
              <SectionItem
                icon={"🧑"}
                title={"Funcionários da Empresa"}
                description={briefingData.structure.employees
                  .map((employee) => employee.name)
                  .join(", ")}
              />
              <SectionItem
                icon={"📏"}
                title={"Tamanho da Empresa"}
                description={briefingData.structure.company_size}
              />
              <SectionItem
                icon={"💰"}
                title={"Modelo de Receita da Empresa"}
                description={briefingData.structure.invoice_model}
              />
              <Divider />
              <SectionItem
                icon={"💡"}
                title={"MARCA"}
                description={
                  "Descrição da identidade e da proposta da marca, com destaque para seus diferenciais e valores. Essas variáveis são essenciais para definir como a empresa se comunica e se diferencia no mercado."
                }
                isTitle
              />
              <SectionItem
                icon={"🎯"}
                title={"Proposta de Valor da Empresa"}
                description={briefingData.brand.company_value}
              />
              <SectionItem
                icon={"🌟"}
                title={"Diferenciais Competitivos da Empresa"}
                description={briefingData.brand.company_differentiators
                  .map((diff) => diff)
                  .join(", ")}
              />
              <Divider />
              <SectionItem
                icon={"🎯"}
                title={"PÚBLICO E MERCADO-ALVO"}
                description={
                  "Definição do público-alvo e dos principais produtos e serviços oferecidos pela empresa. Essas variáveis são úteis para entender quem a empresa atende e o que oferece."
                }
                isTitle
              />
              <SectionItem
                icon={"👤"}
                title={"Público da Empresa"}
                description={briefingData.market_target.public}
              />
              <SectionItem
                icon={"📦"}
                title={"Produtos e Serviços da Empresa"}
                description={briefingData.market_target.services
                  .map((service) => service.name)
                  .join(", ")}
              />
              <Divider />
              <SectionItem
                icon={"🏆"}
                title={"HISTÓRICO E CONQUISTAS"}
                description={
                  "Definição do público-alvo e dos principais produtos e serviços oferecidos pela empresa. Essas variáveis são úteis para entender quem a empresa atende e o que oferece."
                }
                isTitle
              />
              <SectionItem
                icon={"📜"}
                title={"História da Empresa"}
                description={briefingData.history_and_conquests.history}
              />
              <SectionItem
                icon={"🥇"}
                title={"Marcos e Conquistas da Empresa"}
                description={briefingData.history_and_conquests.conquests
                  .map((conquest) => conquest.name)
                  .join(", ")}
              />
            </MainContainer>
          ) : (
            <WaitingMessage />
          )}
        </>
      )}
    </Section>
  );
};

export default Briefing;
